"use strict";

/**
*  Встроенная подсказка
* 
* @class WebAccess.components.notifications.InlineHint
* @extends BaseObject
* @param {object} [opt_settings] Параметры подсказки
* @param {Integer} [opt_dialogId] ИД подсказки
* @since 5.0.0.7300
*
* @example
* var hint = new WA.CMP.NTF.InlineHint()
* hint.showError("Hello world");
*/
(function (global) {
  var InlineHint = BaseObject.extend({
    _jDialog: null,
    _dialogId: 0,
    _customDialogId: false,
    init: function (opt_settings, opt_dialogId) {
      this._super(opt_settings);
      this._dialogId = opt_dialogId;
      if (opt_dialogId) this._customDialogId = true;
      if ($.isPlainObject(opt_settings)) {
        $.extend(this, opt_settings);
      };

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    
    className: 'InlineHint',

    /**
    * Показать встроенную подсказку с предупреждением.
    *
    * @function  WebAccess.components.notifications.InlineHint#showWarning
    * @param {String} message Основной текст предупреждения
    * @param {String} [opt_details] Информационный текст, объясняющий суть предупреждения
    * @return  {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    showWarning: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.WARNING);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать встроенную подсказку с текстом ошибки.
    *
    * @function  WebAccess.components.notifications.InlineHint#showError
    * @param {String} message Основной текст ошибки
    * @param {String} [opt_details] Информационный текст, объясняющий ошибку
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    */
    showError: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.ERROR);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Показать  встроенную подсказку с информационным сообщением.
    *
    * @function  WebAccess.components.notifications.InlineHint#showInfo
    * @param {String} message Основной текст сообщения
    * @param {String} [opt_details] Информационный текст, объясняющий суть сообщения
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.1.0.1511
    */
    showInfo: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.INFO);
      return this;
    },

    /**
    * Показать подсказку в диалоге
    * @function WebAccess.components.notifications.InlineHint#showInDialog
    * @param {String} dialogId Идентификатор целевого диалога
    * @param {String} message Основной текст сообщения
    * @param {String} [opt_details] Информационный текст
    * @param {MESSAGE_TYPE} [opt_messageType] Тип сообщения
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint
    */
    showInDialog: function (dialogId, message, opt_details, opt_messageType) {
      this._dialogId = dialogId;
      this._customDialogId = true;
      return this.show(message, opt_details, opt_messageType);
    },


    _updateContext: function () {
      if (this._customDialogId) return;

      this._dialogId = null;
      
      var jDialog = $('.ui-dialog-content').last();
      if (!jDialog.length) return;
      var jDialogContent = jDialog.children();
      if (jDialogContent.length) {
        this._dialogId = jDialogContent.attr('id');
        if (typeof this._dialogId !== 'undefined') {
          this._dialogId = this._dialogId.replace('dialog_content_', '');
        }
      }
    },

    /**
    * Показать встроенную подсказку.
    *
    * @function  WebAccess.components.notifications.InlineHint#show
    * @param {String} message сОсновной текст сообщения
    * @param {String} [opt_details] Информационный текст
    * @param {MESSAGE_TYPE} [opt_messageType] Тип сообщения
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    */
    show: function (message, opt_details, opt_messageType) {
      var jError;
      var IsError;
      var details = opt_details || '';
      var me = this;

      me._updateContext();

      if (this._dialogId) {
        this._jDialog = $('#dialog_content_' + this._dialogId);
      } else {
        this._jDialog = $();
      };

      opt_messageType = !isNaN(opt_messageType) ? opt_messageType : MESSAGE_TYPE.ERROR;

      try {
        var jsonObject = $.parseJSON(message);
        message = jsonObject.Message;
      } catch (e) {       
      }

      this.hide();
      if (!!$.trim(message)) {
        message = message.newLinesToBR().replaceAll("\u0026quot;", '"');

        if (opt_messageType === MESSAGE_TYPE.ERROR) IsError = true;
        if (opt_messageType !== MESSAGE_TYPE.WARNING && opt_messageType !== MESSAGE_TYPE.ERROR && opt_messageType !== MESSAGE_TYPE.INFO) {
          WA.raise('NOT_IMPLEMENTED_EXCEPTION');
        };

        if (IsError) {
          jError = $("p#errp").first();
        } else {
          jError = $("p#wrnp").first();
        }

        // Для предпросмотра.
        if (jError.length > 1) {
          jError = $(jError[jError.length - 1]);
        }

        var splitterIndex = message.indexOf('^');
        if (splitterIndex != -1) {
          details = message.substring(splitterIndex + 1, message.length).fromISBuilderToNormal();
          message = message.substring(0, splitterIndex);
        }

        var params = WA.TMPL.prepare();
        params.type = IsError ? 'err' : 'wrn';

        params.typeClass = IsError ? 'error' : 'highlight';
        if (opt_messageType == MESSAGE_TYPE.INFO) params.typeClass = 'info';

        params.closeIcon = (IsError ? 'Delete_16.png' : '');
        params.message = message;
        params.details = details;

        var jContainer;
        
        WA.TMPL.render('components/inlineHint.compile.html', params).done(function (html) {
          if (me._jDialog.length) {
            jContainer = me._jDialog.find('#new_error_container');
            if (!!me._jDialog.find('#new_error_container').length) {
              jContainer.remove();
            }
            me._jDialog.prepend(html);
            jContainer = me._jDialog.find('#new_error_container').css({ 'margin-bottom': '15px' });
          } else {
            var isPreviewPage = $('.npocomputer-previewdoc-errors-place-holder').length;
            jContainer = isPreviewPage ? $('.npocomputer-previewdoc-errors-place-holder') : $("[name='ErrorControl']").parent();

            if (!jContainer.length) {
              jContainer = $('#right_column');
              jContainer.prepend(html);
              $('#new_error_container').wrap('<div  class="fake error_content_padding"></div>');
            } else {
              jContainer.find('.ui-state-error').css('display', 'none');
              jContainer.addClass('error_content_padding');
              jContainer.find('div:first').html(html);
            }
          };

          jContainer.find(".error_close").on('click', function () {
            me.hide();
          });
        });
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть последнее открытое сообщение.
    *
    * @function  WebAccess.components.notifications.InlineHint#hide        
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    hide: function () {
      global.InlineHint.hideAll();
      return this;
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~!!~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.InlineHint = InlineHint;

  /**
  * Скрыть все сообщения.
  *
  * @function WebAccess.components.notifications.InlineHint#hideAll
  * @static
  * @since 5.0.0.7300
  */
  global.InlineHint.hideAll = function () {
    $(".error_div_msg").add('#error_container').hide();
    $(".fake.error_content_padding").remove();
    $(".error_content_padding").addClass('error_content_init_padding').removeClass('error_content_padding');
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.WebAccess.components.notifications);